import React from "react"
import {
  Card, CardContent, Typography,
} from "@material-ui/core";
import NoticeEditor from '../rdw/NoticeEditor';
import { EditorState } from 'draft-js';

interface Prop {
  editorState: EditorState
}
const LoginNotice: React.FC<Prop> = (props) => {
  const { editorState } = props
  return (
    <React.Fragment>
      <Card>
        <CardContent>
          <Typography variant="h5" component="h2" style={{ marginBottom: '20px' }} >お知らせ</Typography>
          <NoticeEditor editorState={editorState} />
        </CardContent>
      </Card>
    </React.Fragment>
  )
}
export default LoginNotice